import { propIn } from '../../immutableHelper';

export default (rawState) => propIn(['blocks', 0, 'text'], rawState);
